@if (shouldShow) {
<div class="version-pill">
  @if (type === 'pill') {
  <wp-chips
    [attr.state]="state"
    [attr.contrast]="contrast"
    type="indicator"
    [attr.chip-role]="chipRole"
    [attr.skeleton]="skeleton">
    {{ label }}
  </wp-chips>
  } @if (type === 'bubble') {
  <wp-badge
    [badge-type]="badgeType"
    [attr.info-badge-size]="infoBadgeSize"
    [attr.info-badge-state]="infoBadgeState"
    [attr.data-color]="color"
    [attr.info-badge-border]="false"
    [attr.notification-icon]="true"></wp-badge>
  }
</div>
}
